// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-newsie-editor-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.empty-newsie-content-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  /* background-color: green; */
  justify-content: center;
}

.empty-newsie-cta-text-container {
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/UploadContentNewsie/EmptyNewsieEditor/EmptyNewsieEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;AACA","sourcesContent":[".empty-newsie-editor-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.empty-newsie-content-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  /* background-color: green; */\n  justify-content: center;\n}\n\n.empty-newsie-cta-text-container {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
